import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// context/AiLoaderContext.tsx
import { OBJECTIVES_LOADER_TEXT } from '@/utils/strings';
import React, { createContext, useContext, useState } from 'react';
import { ObjectiveProgressLoader } from '../objective-ai-loader/objective-ai-loader';
import useDashTheme from '../dashboard/useDashTheme';
const DEFAULT_MESSAGE = 'Generating data…';
const AiLoaderContext = createContext(undefined);
export const AiLoaderProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [message, setMessage] = useState(DEFAULT_MESSAGE);
    const show = (msg) => {
        setMessage(msg || DEFAULT_MESSAGE);
        setIsVisible(true);
    };
    const hide = () => {
        setIsVisible(false);
        setMessage(DEFAULT_MESSAGE);
    };
    return (_jsxs(AiLoaderContext.Provider, { value: { show, hide, isVisible, message }, children: [children, isVisible && _jsx(AiLoader, { message: message })] }));
};
export const useAiLoader = () => {
    const context = useContext(AiLoaderContext);
    if (!context) {
        throw new Error('useAiLoader must be used within AiLoaderProvider');
    }
    return context;
};
// Loader UI
const AiLoader = ({ message }) => {
    const isObjectiveLoader = message === OBJECTIVES_LOADER_TEXT;
    // Follow the dashboard's dark/light toggle. The overlay is a fixed portal
    // sibling that can sit outside the `.vdash` container, so carry the theme
    // class here (same pattern as the themed Modal) — otherwise the loader card
    // stays white on a dark dashboard and the dash-* tokens can't resolve.
    const [dashTheme] = useDashTheme();
    const themeClass = `vdash${dashTheme === 'light' ? ' vdash-light' : ''}`;
    return (_jsx("div", { className: `${themeClass} fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm`, role: "dialog", "aria-modal": "true", children: _jsx("div", { className: "flex flex-col items-center space-y-4 rounded-2xl border border-dash-border bg-dash-surface px-7 py-6 shadow-[var(--dash-shadow-pop)]", children: isObjectiveLoader ? (_jsxs(_Fragment, { children: [_jsx("h3", { className: "text-sm font-semibold text-dash-text", children: "Preparing Interview Objectives" }), _jsx(ObjectiveProgressLoader, {})] })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: "relative h-12 w-12", children: [_jsx("div", { className: "absolute inset-0 rounded-full border-4 border-dash-accent/20" }), _jsx("div", { className: "absolute inset-0 animate-spin rounded-full border-4 border-dash-accent border-t-transparent" })] }), _jsx("p", { className: "text-sm font-medium text-dash-text2", children: message })] })) }) }));
};
